import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { Observable } from 'rxjs';

import { apiEndpoint } from '@/app/app/constants/endpoints.const';
import { SKIP_ERROR_TOAST, SKIP_LOADING_INDICATOR } from '@/shared/lib/core/interceptors/header-tokens';

@Service()
export class UsersApi {
  http = inject(HttpClient);

  public registerPushNotificationReference(pushNotificationData: any): Observable<any> {
    return this.http.post<any>(`${apiEndpoint}/accounts/registerPushNotificationReference`, pushNotificationData, {
      context: new HttpContext().set(SKIP_LOADING_INDICATOR, true).set(SKIP_ERROR_TOAST, true),
    });
  }

}
